<template>
    <zip-codes v-slot="{ zipCodes, meta: { pagination } = {}}" :params="params">
        <div class="zip-codes">
            <div class="leading">
                <button class="btn btn-primary" id="show-modal" @click="editZipCode()">Add Zip Code</button>
            </div>

            <div class="row">
                <div class="col-sm">
                    <div class="form-group mb-sm-0">
                        <label for="zip-filter">Keyword</label>
                        <input id="zip-filter" class="form-control" placeholder="Filter by zip code, city name or dealer name or dealer zone name" type="text" v-model="params.keyword">
                    </div>
                </div>
            </div>
            <div v-if="pagination" class="meta header" v-text="filterSummary(pagination)"></div>

            <div class="table-responsive">
                <table class="table table-striped">
                    <thead class="manager-list-heading">
                        <tr>
                            <th>City</th>
                            <th>State</th>
                            <th>Image</th>
                            <th>Zip Code</th>
                            <th>Dealer</th>
                            <th>Zone</th>
                            <th class="actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody class="manager-list-row">
                        <tr v-for="zip in zipCodes" :key="zip.zip_code" :class="{'notice':noZone(zip)}">
                            <td class="city" v-text="zip.city"></td>
                            <td class="state" v-text="zip.state.name"></td>
                            <td v-if="zip.image_path" class="thumbnail"><img :src="zip.image_path" :alt="zip.image_path"></td>
                            <td v-else class="help">No Image</td>
                            <td class="zip_code" v-text="zip.zip_code"></td>
                            <td v-if="zip.zone" class="zone" v-text="zip.zone.company.name"></td>
                            <td v-else class="help">No Dealer</td>
                            <td v-if="zip.zone" class="zone" v-text="zip.zone.name"></td>
                            <td v-else class="focus">No Zone</td>
                            <td class="actions">
                                <button class="btn btn-primary btn-sm" @click="editZipCode(zip.zip_code)">Edit</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="footer">
                <pagination
                    v-if="pagination"
                    v-model="params.page"
                    :total-pages="pagination.last_page"
                    :value="pagination.current_page"
                >
                </pagination>
            </div>

            <zip-code-modal @reindex="filterSummary(pagination)" v-if="showModal" @close="showModal = false;" :id="modalZipCode"></zip-code-modal>
        </div>
    </zip-codes>
</template>
<script>
import Filtering from './helpers/Filtering';
import ZipCodeModal from './ZipCodeModal';
import ModalWatcher from './ModalWatcher';
import { PaginatedCollectionComponent, PaginationNav, LiveSearch, ResetsPage } from 'clockvine-vue';

export default {
    components: {
        ZipCodeModal,
        pagination: PaginationNav,
        zipCodes: PaginatedCollectionComponent.for("zipCodes"),
    },

    mixins: [
        ModalWatcher, 
        Filtering,
    ],

    data: () => ({
        showModal: false,
        modalZipCode: null,
        params: {
			keyword: '',
			page: 1
        }
    }),

    methods: {
        noZone(record) {
            return (record.zone) ? false : true;
        },

        editZipCode(zip_code) {
            this.modalZipCode = zip_code;
            this.showModal = true;
        },
    },
}
</script>
